import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import BootstrapDialogTitle from "../../../components/BootstrapDialogTitle";
import styles from "./ModifyDialog.module.scss";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import MainContext from "../../../context/mainContext";
import workflowService from "../../../services/workflow.service";
import SpinnerArea from "../../../components/SpinnerArea";
import { ICanStartWorfklow } from "../../../models/workflow.model";
import { WorkflowType } from "../../../models/workflow.model";

interface Props {
  open: boolean;
  ticketNumber: string;
  cancelAction: () => void;
  type: WorkflowType;
}

const ModifyDialog: React.FC<Props> = ({
  open,
  ticketNumber,
  cancelAction,
  type,
}) => {
  const { t } = useTranslation();
  const { service } = useContext(MainContext);
  const [reason, setReason] = useState<string>();
  const navigate = useNavigate();
  const [canModify, setCanModify] = useState<ICanStartWorfklow | null>(null);
  const [validating, setValidating] = useState(true);

  const title =
    type === "Modification"
      ? t("modifyPublicationTitle")
      : t("deletePublicationTitle");

  const handleContinue = () => {
    navigate(
      type === "Modification" ? "/modify-publication" : "/delete-publication",
      {
        state: {
          ticketNumber,
          workflowReason: reason,
          workflowType: type,
        },
      }
    );
  };

  useEffect(() => {
    if (ticketNumber) {
      service(() => workflowService.getCanModifiyWorkflow(ticketNumber), {
        callback: (data) => {
          setCanModify(data);
        },
        loader: setValidating,
      });
    }
  }, [ticketNumber]);

  return (
    <Dialog className={styles.modifyDialog} open={open} fullWidth maxWidth="sm">
      <BootstrapDialogTitle onClose={cancelAction}>
        {title}
      </BootstrapDialogTitle>
      <DialogContent>
        <SpinnerArea loading={validating}>
          <TextField
            id="outlined-controlled"
            placeholder={t("modifyPublicationTitle")!}
            disabled={canModify == null || !canModify.canStart}
            value={reason}
            fullWidth
            multiline
            rows={5}
            inputProps={{ maxLength: 2048 }}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setReason(event.target.value);
            }}
          />
          {canModify != null && !canModify.canStart && (
            <Alert variant="standard" severity="warning">
              {t("modifyPublicationWarning", {
                action: type !== "Delete" ? "modify" : "delete",
                ticketNumber: canModify.mostRecentTicketNumber,
              })}
            </Alert>
          )}
        </SpinnerArea>
      </DialogContent>
      <DialogActions>
        <Button
          className={styles.no}
          variant="text"
          onClick={() => {
            cancelAction();
            setReason("");
          }}
        >
          {t("cancel")}
        </Button>
        <Button
          className={styles.yes}
          variant="contained"
          onClick={handleContinue}
          disabled={!reason || !canModify}
        >
          {t("continue")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModifyDialog;
